import { createGlobalStyle } from "styled-components";



const Global = createGlobalStyle`

  * {
    margin: 0;
    padding: 0;
    font-family: system-ui, -apple-system, Helvetica, sans-serif;
  }
  
  
  body {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow-x: hidden;
    overflow-y: auto;
    margin: 0; 
    background-color: #F7F7F7;

  }
  
   /* Estilizando a scrollbar para toda a aplicação */
  ::-webkit-scrollbar {
    width: 12px;
    height: 12px;
  }

  ::-webkit-scrollbar-track {
    background: #f0f0f0;
    border-radius: 6px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 6px;
    border: 3px solid #f0f0f0;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #555;
  }

  .fullscreen {
  width: 100vw;
  height: calc(var(--vh) * 100); /* Isso substitui 100vh */
  background: red;
}
`;





export default Global;